module.exports = __webpack_public_path__ + "h5/img/wechat.2702cfca.png";